// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","ofertaLink":"Footer_ofertaLink__NVZ96","linksWrapper":"Footer_linksWrapper__342ax","link":"Footer_link__9_ojg"};